const isSupportedStreamingServiceLink = (link: string): boolean =>
	link.match(
		/(youtu\.be|youtube\.com|ytimg\.com|vimeo\.com|vimeocdn\.com|vimeopro\.com|tiktok\.com|open\.spotify\.com|soundcloud\.com|music\.apple\.com)/i
	) !== null

export default isSupportedStreamingServiceLink
